export var SamplingPolicy;
(function (SamplingPolicy) {
    SamplingPolicy[SamplingPolicy["NotSet"] = 0] = "NotSet";
    SamplingPolicy[SamplingPolicy["Measure"] = 1] = "Measure";
    SamplingPolicy[SamplingPolicy["Diagnostics"] = 2] = "Diagnostics";
    SamplingPolicy[SamplingPolicy["CriticalBusinessImpact"] = 191] = "CriticalBusinessImpact";
    SamplingPolicy[SamplingPolicy["CriticalCensus"] = 192] = "CriticalCensus";
    SamplingPolicy[SamplingPolicy["CriticalExperimentation"] = 193] = "CriticalExperimentation";
    SamplingPolicy[SamplingPolicy["CriticalUsage"] = 194] = "CriticalUsage";
})(SamplingPolicy || (SamplingPolicy = {}));
export var PersistencePriority;
(function (PersistencePriority) {
    PersistencePriority[PersistencePriority["NotSet"] = 0] = "NotSet";
    PersistencePriority[PersistencePriority["Normal"] = 1] = "Normal";
    PersistencePriority[PersistencePriority["High"] = 2] = "High";
})(PersistencePriority || (PersistencePriority = {}));
export var CostPriority;
(function (CostPriority) {
    CostPriority[CostPriority["NotSet"] = 0] = "NotSet";
    CostPriority[CostPriority["Normal"] = 1] = "Normal";
    CostPriority[CostPriority["High"] = 2] = "High";
})(CostPriority || (CostPriority = {}));
/**
 * DataCategories
 * These can be combined with | as appropriate
 */
export var DataCategories;
(function (DataCategories) {
    DataCategories[DataCategories["NotSet"] = 0] = "NotSet";
    DataCategories[DataCategories["SoftwareSetup"] = 1] = "SoftwareSetup";
    DataCategories[DataCategories["ProductServiceUsage"] = 2] = "ProductServiceUsage";
    DataCategories[DataCategories["ProductServicePerformance"] = 4] = "ProductServicePerformance";
    DataCategories[DataCategories["DeviceConfiguration"] = 8] = "DeviceConfiguration";
    DataCategories[DataCategories["InkingTypingSpeech"] = 16] = "InkingTypingSpeech";
})(DataCategories || (DataCategories = {}));
/**
 * The diagnostic level of the event
 * For generic events, a user can be set to send no events, only basic events, or all (full and basic) events.
 * Services can also send events that are necessary for them to function; these are not affected by the above setting.
 * Instead, if the service is turned off, then it will stop functioning and no NecessaryServiceDataEvents will be sent.
 * AlwaysOnNecessaryServiceDataEvents are always on.
 */
export var DiagnosticLevel;
(function (DiagnosticLevel) {
    DiagnosticLevel[DiagnosticLevel["ReservedDoNotUse"] = 0] = "ReservedDoNotUse";
    DiagnosticLevel[DiagnosticLevel["BasicEvent"] = 10] = "BasicEvent";
    DiagnosticLevel[DiagnosticLevel["FullEvent"] = 100] = "FullEvent";
    DiagnosticLevel[DiagnosticLevel["NecessaryServiceDataEvent"] = 110] = "NecessaryServiceDataEvent";
    DiagnosticLevel[DiagnosticLevel["AlwaysOnNecessaryServiceDataEvent"] = 120] = "AlwaysOnNecessaryServiceDataEvent";
})(DiagnosticLevel || (DiagnosticLevel = {}));
//# sourceMappingURL=EventFlagsProperties.js.map